// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/TickerSeriesList/styles.scss
// module id = 1072
// module chunks = 0